import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import './Footer.scss';
export function Footer() {
    return (_jsx("footer", { className: "footer", children: _jsx("p", { children: "\u00A9 \u7528\u53CB\u7F51\u7EDC\u79D1\u6280\u80A1\u4EFD\u6709\u9650\u516C\u53F8\u7248\u6743\u6240\u6709\u4EACICP\u590705007539\u53F7-24\u4EAC\u516C\u7F51\u5B89\u5907 11010802021935\u53F7" }) }));
}
